import React, { useEffect } from 'react';
import { toast } from 'react-toastify';

import { IGroup } from '../../../../types/Groups/groupsInterfaces';

import { SideBarDeleteActionWithPopup } from '../../../../components/commons/SideBarComponents/DeleteActionWithPopup/sideBarDeleteActionWithPopup';
import { SideBarReadOnly } from '../../../../components/commons/SideBarComponents/ReadOnlyItems/sideBarReadOnly';
import {
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import Strings from '../../../../i18n';
import { useDeleteGroupMutation } from '../../../../services/groups/groupsService';
import { SideBarSimpleMethodItem } from '../../../../components/commons/SideBarComponents/SimpleMethodItem/sideBarSimpleMethodButtonItem';

interface detailsGroupProps {
  reloadTable: () => void;
  group: IGroup;
  redirectToXSeriesSetup: () => void;
}

export const DetailsGroupBar = ({
  reloadTable,
  group,
  redirectToXSeriesSetup
}: detailsGroupProps) => {
  const [deleteGroupById, { isSuccess: isSuccessDelete }] =
    useDeleteGroupMutation();

  const deleteGroup = () => {
    deleteGroupById(group.groupId);
  };

  useEffect(() => {
    if (isSuccessDelete) {
      toast.success(Strings.groups.successDeleteGroup);
      reloadTable();
    }
  }, [isSuccessDelete]);
  return (
    <div>
      <StyledContainerItems>
        <StyledTitleSideBar>{group.shortName}</StyledTitleSideBar>
        <SideBarReadOnly
          readOnlyItems={[
            {
              name: Strings.common.name,
              value: group.groupName
            },
            {
              name: 'Lights',
              value: group.lights.map((light: any) => light.name).join(', ')
            },
            {
              name: 'Is On',
              value: group.isOn ? 'Yes' : 'No'
            }
          ]}
        />

        {group.capabilities.some(
          (capability) => capability.name === 'TRIM_LIGHT'
        ) && (
          <SideBarSimpleMethodItem
            name={Strings.groups.xSeriesSetup}
            action={redirectToXSeriesSetup}
            successAction={false}
            textSuccess="success"
          />
        )}

        <SideBarDeleteActionWithPopup
          onDelete={() => deleteGroup()}
          titleConfirmation={Strings.groups.deleteGroup}
          textConfirmation={Strings.common.thisActionIsIrreversible}
          textIcon={Strings.groups.confirmDeleteGroup}
        />
      </StyledContainerItems>
    </div>
  );
};
